import logEvent from 'analytics/logEvent';
import cn from 'classnames';
import React from 'react';
import type { FC } from 'react';

import Icon, { IconTypes } from 'components/basic/Icon';
import { BodyL, BodyM } from 'components/basic/Typography';
import s from 'components/layouts/FullFooter/FullFooter.module.scss';
import { appsItems } from 'components/layouts/FullFooter/constants';

import { useAppSelector } from 'redux-store';

const AppsItems: FC = () => {
  const { appleOneLinkUrl, googleOneLinkUrl } = useAppSelector(
    state => state.experiments,
  );
  const items = appsItems.map(({ analyticsButtonId, text, href, icon }) => {
    let currentHref = href;

    if (analyticsButtonId === 'appstore') {
      currentHref = appleOneLinkUrl;
    }

    if (analyticsButtonId === 'googleplay') {
      currentHref = googleOneLinkUrl;
    }

    return (
      <BodyM
        key={analyticsButtonId}
        Tag="a"
        href={currentHref}
        className={s.link}
        target="_blank"
        onClick={(): void => {
          logEvent('Web_Site_Footer_Store_Button_Clicked', {
            button_id: analyticsButtonId,
          });
        }}
      >
        <Icon icon={IconTypes[icon]} className={s.appIcon} />
        {text}
      </BodyM>
    );
  });

  return (
    <div key="mobile">
      <BodyL className={cn('mb-5', s.header)}>Get the mobile app</BodyL>
      {items}
    </div>
  );
};

export default AppsItems;
